// @flow
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitRating, toggleRatingDlg, setRatingParams } from '../actions/rating.js';
import type { RatingState } from '../reducers/rating';

const useRating = () => {
	const rating = useSelector<RatingState>((state) => state.rating);
	const dispatch = useDispatch();

	const submitRatingCb = useCallback(
		(data: { [key: string]: any }) => {
			dispatch(submitRating(data));
		},
		[dispatch]
	);

	const toggleRatingDlgCb = useCallback(
		(state: boolean) => {
			dispatch(toggleRatingDlg(state));
		},
		[dispatch]
	);

	const setRatingParamsCb = useCallback(
		({type, pod}: {type: string, pod: string}) => {
			dispatch(setRatingParams({type, pod}));
		},
		[dispatch]
	);

	return [rating, submitRatingCb, toggleRatingDlgCb, setRatingParamsCb];
};

export default useRating;
